export default function () {
  return {
    cachepieseschimb: [],
    cachepieseschimbCurrentPage: 1,
    cachepieseschimbLastPage: 1,
    cachepieseschimbPerPage: 0,
    cachepieseschimbTotal: 0,
    cachepieseschimbLoading: false,
    indexPage: null
  }
}
